import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { ServiceOrder } from '@/models/serviceOrder'
import api from '@/shared/api'
import { ENDPOINTS, SERVICE_ORDER_STATUS } from '@/shared/constants'
import { RootState } from '../'
import { isPast } from 'date-fns'
import { toast } from 'react-toastify'

export interface ServiceOrdersState {
  serviceOrders: ServiceOrder[]
  loading: boolean
  error: string | null
}

// Estado inicial
const initialState: ServiceOrdersState = {
  serviceOrders: [],
  loading: false,
  error: null,
}

// Função para buscar itens da API
export const fetchServiceOrders = createAsyncThunk<ServiceOrder[]>(
  'serviceOrders/fetchServiceOrders',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(ENDPOINTS.SERVICE_ORDERS.GET.ALL)

      return (await response.data) as ServiceOrder[]
    } catch (error: unknown) {
      toast.error('Erro ao listar listas de ordens de serviço')
      let errorMessage = 'Unknown error'

      if (error instanceof Error) {
        errorMessage = error.message
      }

      return thunkAPI.rejectWithValue(errorMessage)
    }
  }
)

// Slice
const serviceOrdersSlice = createSlice({
  name: 'serviceOrders',
  initialState,
  reducers: {
    // Exemplo de reducer adicional, se necessário
    clearError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceOrders.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchServiceOrders.fulfilled,
        (state, action: PayloadAction<ServiceOrder[]>) => {
          state.loading = false
          state.serviceOrders = action.payload
        }
      )
      .addCase(fetchServiceOrders.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

// Exporta ações e reducer
export const { clearError } = serviceOrdersSlice.actions
export default serviceOrdersSlice.reducer

// Selector
export const delayedServiceOrdersTotal = (state: RootState) => {
  return state.serviceOrders.serviceOrders.filter(
    (serviceOrder) =>
      serviceOrder.status !== SERVICE_ORDER_STATUS.FINISHED &&
      isPast(serviceOrder.dueDate)
  ).length
}
